import { useState, useEffect, memo, useCallback } from "react";
import AnimacionCarga from "./animacion_de_carga";
import TablaGenerica from "./tablas";
import { obtenerEncomiendas } from "../../functions/consultas";
import BotonSOS from "./sos/boton_sos";
import Swal from "sweetalert2";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import { crearRegistro, actualizarMultiple, consultarSimple } from "../../functions/crud";
import { descargarPlantillaEncomiendas } from "../../functions/importar_encomiendas";
import {
  correoDeVivienda, correoExcluido, enviarCorreoEncomienda, enviarCorreoEntregaEncomienda, mensajeNotificacion,
} from "../../functions/correos_backend";
import { asistenteCargarEncomiendas, menuAccionesEncomienda, menuArchivosEncomiendas } from "./dialogos_encomiendas";
import {
  BarraEstados, BotonArchivos, abrirMenuArchivos, botonOpciones, eliminarConConfirmacion, esResidente, filtrarPorEstado, mostrarFotos, soloDelResidente,
} from "./listado_comun";
import {
  ESTADOS_ENCOMIENDA,
  MAX_FOTOS,
  rutaColeccionEncomiendas,
  rutaEncomienda,
  viviendaNotificacion,
  viviendaCorreo,
  nuevaEncomienda,
  bitacoraCreacion,
  bitacoraGestion,
} from "../../functions/encomienda";
import {
  esPorteria,
  fechaHoraDart,
  fechaDart,
  fechaHora12Dart,
  formatearFechaListado,
  parsearFechaPase,
  construirDireccion,
  opcionesVivienda,
} from "../../functions/pase_visitante";
import "bootstrap-icons/font/bootstrap-icons.css";

// estilo: ancho de cada columna; las fechas van en una sola línea.
const FECHA = { whiteSpace: "nowrap" };
const COLUMNAS = [
  { label: "Fecha creación", key: "fechaCreacion", estilo: FECHA },
  { label: "Dirección", key: "vivienda", estilo: { minWidth: 180, maxWidth: 200 } },
  { label: "Registrado por", key: "usuario", estilo: { width: 110, maxWidth: 130 } },
  { label: "Quién lo trae", key: "quienLoTrae", estilo: { width: 120, maxWidth: 150 } },
  { label: "Descripción", key: "descripcionDomicilio", estilo: { minWidth: 180 } },
  { label: "Estado", key: "estado", estilo: { width: 95 } },
  { label: "Recibe", key: "nombre_completo_persona_recibe_paquete", estilo: { minWidth: 130 } },
  { label: "Fecha entrega", key: "fecha_hora_entrega", estilo: FECHA },
];

const fotosDe = (encomienda) =>
  [1, 2, 3, 4, 5, 6].map(n => encomienda[`url_encomienda_${n}`]).filter(Boolean);

// Formularios de crear y gestionar (no dependen del estado del listado).

// Como en la app, solo portería (GUARDA, ADMINISTRADOR, SUPER) elige la vivienda; los demás
// registran el paquete a su propia dirección.
const generarFormularioCrear = () => {
  const opciones = opcionesVivienda();
  const porteria = esPorteria();

  return `
  <style>
    #enc-crear .swal2-input, #enc-crear .swal2-textarea, #enc-crear .swal2-select {
      margin: 0 !important; width: 100% !important; box-sizing: border-box !important;
      padding: 10px !important; border: 1px solid #d1d5db !important;
      border-radius: 5px !important; font-size: 14px !important;
    }
    #enc-crear .swal2-textarea { min-height: 70px !important; resize: vertical !important; }
    #enc-crear .campo-label {
      display:block; margin-bottom:6px; color:#555; font-size:14px; font-weight:500;
    }
    #enc-crear .fila { display:flex; gap:12px; margin-bottom:15px; }
    #enc-crear .col { flex:1; }
    #enc-crear .miniatura {
      position:relative; width:90px; height:90px; border-radius:8px;
      overflow:hidden; border:1px solid #e2e6ea; flex:0 0 auto;
    }
    #enc-crear .miniatura img { width:100%; height:100%; object-fit:cover; display:block; }
    #enc-crear .quitar {
      position:absolute; top:2px; right:2px; width:22px; height:22px;
      border:none; border-radius:50%; background:rgba(0,0,0,.6); color:#fff;
      font-size:14px; line-height:1; cursor:pointer;
    }
  </style>
  <div id="enc-crear" style="text-align:left;padding:20px;">
    <h3 style="margin:0 0 25px;color:#2c3e50;font-size:20px;font-weight:600;">
      Crear encomienda
    </h3>

    ${porteria ? `
    <div style="margin-bottom:15px;">
      <label class="campo-label">Dirección de la vivienda</label>
      <select id="selectorVivienda" class="swal2-select">
        ${opciones.map(op => `<option value="${op}">${op}</option>`).join('')}
      </select>
    </div>` : `
    <div style="margin-bottom:15px;">
      <label class="campo-label">Dirección de la vivienda</label>
      <input class="swal2-input" readonly value="${localStorage.getItem("Direccion") || ""}"
        style="background:#d3d3d3;cursor:not-allowed;">
    </div>`}

    <div id="bloqueVivienda" style="display:${porteria ? "block" : "none"};">
      <div class="fila">
        <div class="col">
          <label class="campo-label">Tipo de vivienda</label>
          <select id="tipoCasa" class="swal2-select">
            <option value="APARTAMENTO" selected>APARTAMENTO</option>
            <option value="CASA">CASA</option>
          </select>
        </div>
        <div class="col">
          <label class="campo-label">No Torre/Etapa</label>
          <input id="indicadorSector" class="swal2-input" placeholder="Número">
        </div>
        <div class="col">
          <label class="campo-label">No Casa</label>
          <input id="indicadorCasa" class="swal2-input" placeholder="Número">
        </div>
      </div>
      <div style="margin-bottom:15px;">
        <label class="campo-label">Dirección</label>
        <input id="direccionArmada" class="swal2-input" readonly
          value="${construirDireccion('APARTAMENTO', '', '')}"
          style="background:#d3d3d3;cursor:not-allowed;">
      </div>
    </div>

    <div style="margin-bottom:15px;">
      <label class="campo-label">Quién lo trae</label>
      <input id="quienLoTrae" class="swal2-input" placeholder="Agregue quién envía el paquete.">
    </div>

    <div style="margin-bottom:15px;">
      <label class="campo-label">Descripción</label>
      <textarea id="descripcion" class="swal2-textarea" placeholder="Agregue el domicilio a recibir."></textarea>
    </div>

    <div style="margin-bottom:8px;">
      <label class="campo-label">Agregar Fotos</label>
      <div id="contadorFotos" style="color:#6b7280;font-size:13px;margin-bottom:8px;">0 de ${MAX_FOTOS}</div>
      <input id="archivo" type="file" accept="image/*" multiple class="swal2-input" style="padding:8px !important;">
      <div id="preview" style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px;"></div>
    </div>
  </div>
`;
};

let fotosCrear = [];

const configurarEventosFormularioCrear = () => {
  fotosCrear = [];

  const selector = document.getElementById("selectorVivienda");
  const bloque = document.getElementById("bloqueVivienda");
  const tipoCasa = document.getElementById("tipoCasa");
  const sector = document.getElementById("indicadorSector");
  const numero = document.getElementById("indicadorCasa");
  const direccion = document.getElementById("direccionArmada");

  const refrescarDireccion = () => {
    direccion.value = construirDireccion(tipoCasa.value, sector.value, numero.value);
  };
  const alternarBloque = () => {
    bloque.style.display =
      selector.value === "ADICIONAR MANUALMENTE" ? "block" : "none";
  };

  if (selector) {
    selector.addEventListener("change", alternarBloque);
    alternarBloque();
  }
  [sector, numero].forEach(c => c.addEventListener("input", refrescarDireccion));
  tipoCasa.addEventListener("change", refrescarDireccion);

  const archivo = document.getElementById("archivo");
  const preview = document.getElementById("preview");
  const contador = document.getElementById("contadorFotos");

  const pintar = () => {
    contador.textContent = `${fotosCrear.length} de ${MAX_FOTOS}`;
    preview.innerHTML = fotosCrear
      .map((f, i) => `
        <div class="miniatura">
          <img src="${URL.createObjectURL(f)}">
          <button type="button" class="quitar" data-i="${i}">&times;</button>
        </div>`)
      .join("");
    preview.querySelectorAll(".quitar").forEach(btn =>
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        fotosCrear.splice(Number(btn.dataset.i), 1);
        pintar();
      })
    );
  };

  archivo.addEventListener("change", () => {
    const nuevos = Array.from(archivo.files || []);
    const espacio = MAX_FOTOS - fotosCrear.length;
    if (nuevos.length > espacio) {
      Swal.showValidationMessage(`Solo se permiten ${MAX_FOTOS} fotos`);
    }
    fotosCrear = [...fotosCrear, ...nuevos.slice(0, Math.max(espacio, 0))];
    archivo.value = "";
    pintar();
  });

  pintar();
};

const validarYObtenerDatosCrear = () => {
  const seleccion = document.getElementById("selectorVivienda")?.value;
  const quienLoTrae = document.getElementById("quienLoTrae").value.trim();
  const descripcion = document.getElementById("descripcion").value.trim();

  if (!quienLoTrae) {
    Swal.showValidationMessage("Debe agregar quién lo trae.");
    return false;
  }
  if (!descripcion) {
    Swal.showValidationMessage("Debe añadir una descripción para agregar domicilio.");
    return false;
  }

  let vivienda;
  if (!esPorteria()) {
    vivienda = localStorage.getItem("Direccion") || "";
  } else if (seleccion === "ADICIONAR MANUALMENTE") {
    const tipoCasa = document.getElementById("tipoCasa").value;
    const sector = document.getElementById("indicadorSector").value.trim();
    const numero = document.getElementById("indicadorCasa").value.trim();
    if (!numero) {
      Swal.showValidationMessage("Ingrese Dirección");
      return false;
    }
    vivienda = construirDireccion(tipoCasa, sector, numero);
  } else {
    vivienda = seleccion;
  }

  return { vivienda, quienLoTrae, descripcion, fotos: [...fotosCrear] };
};

const generarFormularioGestion = (encomienda) => `
  <style>
    #enc-form .swal2-input, #enc-form .swal2-textarea, #enc-form .swal2-select {
      margin: 0 !important; width: 100% !important; box-sizing: border-box !important;
      padding: 8px 10px !important; border: 1px solid #e2e6ea !important;
      border-radius: 6px !important; font-size: 13px !important; color: #2c3e50 !important;
    }
    #enc-form .swal2-textarea { min-height: 44px !important; max-height: 90px !important; resize: none !important; }
    #enc-form label { display:block; margin-bottom:4px; color:#6b7280; font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:.5px; }
    #enc-form .field { margin-bottom:8px; }
    #enc-form .row { display:flex; gap:10px; }
    #enc-form .row .field { flex:1; }
    #enc-form .readonly-val { background:#f8f9fb !important; color:#555 !important; cursor:default !important; }
    #enc-form .section-title { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:.8px; color:#94a3b8; margin:10px 0 8px; border-top:1px solid #f1f5f9; padding-top:8px; }
    #enc-form .galeria { display:flex; gap:8px; flex-wrap:wrap; margin-bottom:8px; }
    #enc-form .galeria img { width:80px; height:80px; object-fit:cover; border-radius:8px; border:1px solid #e2e6ea; }
    #enc-form .file-label { display:flex; align-items:center; gap:8px; padding:8px 12px; border:1px dashed #cbd5e1; border-radius:6px; cursor:pointer; color:#64748b; font-size:12px; background:#f8f9fb; }
    #enc-form .file-label:hover { border-color:#6366f1; color:#6366f1; }
    #enc-form #archivo-editar { display:none; }
    #enc-form .firma-canvas { border:1px solid #e2e6ea; border-radius:8px; cursor:crosshair; touch-action:none; background:#fff; display:block; width:100%; height:100px; }
    #enc-form .firma-guardada { border-radius:8px; overflow:hidden; border:1px solid #e2e6ea; margin-bottom:8px; background:#f8f9fb; text-align:center; padding:10px; }
    #enc-form .firma-guardada img { max-height:100px; max-width:100%; object-fit:contain; }
    #enc-form .badge-ok { display:inline-block; font-size:11px; font-weight:600; color:#16a34a; background:#dcfce7; border-radius:20px; padding:2px 10px; margin-bottom:6px; }
    #enc-form .btn-sm { padding:6px 14px; border:none; border-radius:6px; font-size:12px; font-weight:600; cursor:pointer; }
    #enc-form .btn-outline { background:#f1f5f9; color:#475569; }
  </style>
  <div id="enc-form" style="text-align:left;padding:0 16px 4px;">

    <div class="section-title">Información del paquete</div>

    <div class="row">
      <div class="field">
        <label>Dirección</label>
        <input readonly class="swal2-input readonly-val" value="${encomienda.vivienda || ''}">
      </div>
      <div class="field">
        <label>Quién lo trae</label>
        <input readonly class="swal2-input readonly-val" value="${encomienda.quienLoTrae || ''}">
      </div>
    </div>

    <div class="field">
      <label>Descripción</label>
      <textarea readonly class="swal2-textarea readonly-val">${encomienda.descripcionDomicilio || ''}</textarea>
    </div>

    <div class="section-title">Gestión</div>

    <div class="row">
      <div class="field">
        <label>Estado</label>
        <select id="estado" class="swal2-select">
          ${ESTADOS_ENCOMIENDA.map(est =>
            `<option value="${est}" ${encomienda.estado === est ? 'selected' : ''}>${est}</option>`
          ).join('')}
        </select>
      </div>
      <div class="field">
        <label>Nombre de quien recibe</label>
        <input id="quienRecibe" class="swal2-input" placeholder="Nombre completo"
          value="${encomienda.nombre_completo_persona_recibe_paquete || ''}">
      </div>
    </div>

    <div class="section-title">Fotos del paquete</div>

    ${[1, 2, 3, 4, 5, 6]
      .map(n => encomienda[`url_encomienda_${n}`])
      .filter(Boolean).length
      ? `<div class="galeria">
          ${[1, 2, 3, 4, 5, 6]
            .map(n => encomienda[`url_encomienda_${n}`])
            .filter(Boolean)
            .map(url => `<img src="${url}">`)
            .join('')}
         </div>`
      : ''}
    <label class="file-label" for="archivo-editar">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
      Agregar fotos
    </label>
    <input id="archivo-editar" type="file" accept="image/*" multiple>
    <div id="preview-editar" style="display:flex;gap:8px;flex-wrap:wrap;margin-top:8px;"></div>

    <div class="section-title">Firma de quien recibe</div>

    <div id="firma-wrap">
      ${encomienda.url_firma_cliente ? `
        <div class="firma-guardada">
          <span class="badge-ok">Firma registrada</span><br>
          <img src="${encomienda.url_firma_cliente}">
        </div>
        <button type="button" id="btn-cambiar-firma" class="btn-sm btn-outline">Dibujar nueva firma</button>
      ` : ''}
      <canvas id="canvas-firma" class="firma-canvas" width="600" height="100"
        style="display:${encomienda.url_firma_cliente ? 'none' : 'block'};margin-top:8px;">
      </canvas>
      <div style="margin-top:6px;display:${encomienda.url_firma_cliente ? 'none' : 'flex'};gap:8px;" id="firma-btns">
        <button type="button" id="btn-limpiar-firma" class="btn-sm btn-outline">Limpiar</button>
      </div>
    </div>

  </div>
`;

let fotosGestion = [];
let firmaDibujada = null;

const configurarEventosFormularioGestion = (encomienda) => {
  fotosGestion = [];
  firmaDibujada = null;

  const archivoEditar = document.getElementById("archivo-editar");
  const previewEditar = document.getElementById("preview-editar");

  const yaUsadas = [1, 2, 3, 4, 5, 6]
    .filter(n => encomienda[`url_encomienda_${n}`]).length;

  const pintar = () => {
    previewEditar.innerHTML = fotosGestion
      .map(f => `<img src="${URL.createObjectURL(f)}" style="width:80px;height:80px;object-fit:cover;border-radius:8px;border:1px solid #e2e6ea;">`)
      .join("");
  };

  if (archivoEditar) {
    archivoEditar.addEventListener("change", () => {
      const nuevos = Array.from(archivoEditar.files || []);
      const espacio = MAX_FOTOS - yaUsadas - fotosGestion.length;
      if (nuevos.length > espacio) {
        Swal.showValidationMessage(`Solo quedan ${Math.max(espacio, 0)} espacios de foto`);
      }
      fotosGestion = [...fotosGestion, ...nuevos.slice(0, Math.max(espacio, 0))];
      archivoEditar.value = "";
      pintar();
    });
  }

  const canvas = document.getElementById("canvas-firma");
  const btnLimpiar = document.getElementById("btn-limpiar-firma");
  const btnCambiar = document.getElementById("btn-cambiar-firma");
  const firmaBtns = document.getElementById("firma-btns");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  let dibujando = false;
  ctx.strokeStyle = "#1e293b";
  ctx.lineWidth = 2;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";

  const obtenerPosicion = (e) => {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const x = ((e.clientX || e.touches?.[0]?.clientX) - rect.left) * scaleX;
    const y = ((e.clientY || e.touches?.[0]?.clientY) - rect.top) * scaleY;
    return { x, y };
  };

  const iniciarDibujo = (e) => {
    dibujando = true;
    const punto = obtenerPosicion(e);
    ctx.beginPath();
    ctx.moveTo(punto.x, punto.y);
  };
  const dibujar = (e) => {
    if (!dibujando) return;
    e.preventDefault();
    const punto = obtenerPosicion(e);
    ctx.lineTo(punto.x, punto.y);
    ctx.stroke();
    firmaDibujada = true;
  };
  const detenerDibujo = () => {
    if (dibujando) { dibujando = false; ctx.closePath(); }
  };

  canvas.addEventListener("mousedown", iniciarDibujo);
  canvas.addEventListener("mousemove", dibujar);
  canvas.addEventListener("mouseup", detenerDibujo);
  canvas.addEventListener("mouseout", detenerDibujo);
  canvas.addEventListener("touchstart", (e) => { e.preventDefault(); iniciarDibujo(e); });
  canvas.addEventListener("touchmove", dibujar);
  canvas.addEventListener("touchend", detenerDibujo);

  if (btnLimpiar) {
    btnLimpiar.addEventListener("click", (e) => {
      e.preventDefault();
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      firmaDibujada = null;
    });
  }
  if (btnCambiar) {
    btnCambiar.addEventListener("click", (e) => {
      e.preventDefault();
      canvas.style.display = "block";
      if (firmaBtns) firmaBtns.style.display = "flex";
      btnCambiar.style.display = "none";
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      firmaDibujada = null;
    });
  }
};

const obtenerFirmaDelLienzo = () => {
  const canvas = document.getElementById("canvas-firma");
  if (!canvas || !firmaDibujada) return null;
  const ctx = canvas.getContext("2d");
  const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
  for (let i = 3; i < data.length; i += 4) {
    if (data[i] !== 0) return canvas.toDataURL("image/png");
  }
  return null;
};

const validarYObtenerDatosGestion = (encomienda) => {
  const estado = document.getElementById("estado").value;
  const quienRecibe = document.getElementById("quienRecibe").value.trim();
  const firmaNueva = obtenerFirmaDelLienzo();
  const firmaPrevia = encomienda.url_firma_cliente || "";

  if (estado === "Entregado") {
    if (!quienRecibe) {
      Swal.showValidationMessage("Debe indicar el nombre de quien recibe el paquete");
      return false;
    }
    if (!firmaNueva && !firmaPrevia) {
      Swal.showValidationMessage("Debe registrar la firma de quien recibe");
      return false;
    }
  }

  return { estado, quienRecibe, firmaNueva, fotos: [...fotosGestion] };
};

const ListadoEncomiendas = memo(() => {
  const [datos, setDatos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState(null);

  const capturarDatos = useCallback(async () => {
    try {
      const data = await obtenerEncomiendas();

      const lista = data.map(item => ({
        ...item,
        fechaCreacionOriginal: item.fechaCreacion,
        fechaCreacion: formatearFechaListado(item.fechaCreacion),
        fecha_hora_entrega: item.fecha_fin_encomienda && item.hora_fin_encomienda
          ? formatearFechaListado(`${item.fecha_fin_encomienda} ${item.hora_fin_encomienda}`)
          : item.fecha_fin_encomienda || item.hora_fin_encomienda || "",
      }));
      setDatos(soloDelResidente(lista, "vivienda"));
    } catch (e) {
      console.error(e);
    } finally {
      setCargando(false);
    }
  }, []);

  const crearEncomienda = useCallback(async () => {
    const { value: formValues } = await Swal.fire({
      title: "Crear encomienda",
      html: generarFormularioCrear(),
      didOpen: configurarEventosFormularioCrear,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      width: 600,
      preConfirm: () => validarYObtenerDatosCrear(),
    });

    if (!formValues) return;

    try {
      Swal.fire({ title: "Guardando", didOpen: () => Swal.showLoading(), allowOutsideClick: false });

      const nit = localStorage.getItem("CodigoCliente");
      const nombreCompleto = localStorage.getItem("NombreCompleto") || "";

      const fechaObtenida = fechaHoraDart();
      const soloFecha = fechaObtenida.substring(0, 10);
      const soloHora = fechaObtenida.substring(11, 16);

      const year = soloFecha.substring(0, 4);
      const mes = soloFecha.substring(5, 7);

      const urls = {};
      for (let i = 0; i < formValues.fotos.length && i < MAX_FOTOS; i++) {
        urls[`url_encomienda_${i + 1}`] = await subirArchivoFirebase(
          `uploads/${nit}/${fechaObtenida}foto_${i}.jpeg`,
          formValues.fotos[i]
        );
      }

      const correoNotificacion = await consultarSimple(
        `notificaciones/${nit}/${viviendaCorreo(formValues.vivienda)}`
      );
      const correo = typeof correoNotificacion === "string" ? correoNotificacion : null;

      // En la app solo el residente deja el paquete Pendiente (lo anuncia antes de que llegue).
      const estado = esResidente() ? "Pendiente" : "Recibido";

      const registro = nuevaEncomienda({
        fechaCreacion: fechaObtenida,
        vivienda: formValues.vivienda,
        usuario: nombreCompleto,
        descripcionDomicilio: formValues.descripcion,
        estado,
        quienLoTrae: formValues.quienLoTrae,
        fecha_inicio_encomienda: soloFecha,
        hora_inicio_encomienda: soloHora,
        descripcion_encomienda: bitacoraCreacion(nombreCompleto, soloFecha),
        correoNotificacion: correo,
        ...urls,
      });

      const ruta = rutaColeccionEncomiendas(nit, year, mes);
      const id = await crearRegistro(ruta, registro);

      let aviso = "";
      if (esPorteria()) {
        await actualizarMultiple({
          [`coordi_ph_clientes/${nit}/fcm_encomiendas/recibido/${viviendaNotificacion(formValues.vivienda)}`]:
            { id, fecha: fechaObtenida },
        });

        // Correo al residente, igual que crear_encomienda.dart (salvo correos excluidos).
        const excluido = Boolean(correo) && await correoExcluido(correo);
        let enviado = false;
        if (correo && !excluido) {
          enviado = await enviarCorreoEncomienda({
            correo,
            urlFoto: registro.url_encomienda_1,
            quienLoTrae: registro.quienLoTrae,
            contenido: registro.descripcionDomicilio,
            direccion: registro.vivienda,
          });
        }
        aviso = mensajeNotificacion({ correo, excluido, enviado });
      }

      Swal.fire({ title: "Éxito", html: `Encomienda generada con éxito${aviso}`, icon: "success", confirmButtonText: "Aceptar" });
      capturarDatos();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo registrar la encomienda", "error");
    }
  }, [capturarDatos]);

  const gestionarEncomienda = useCallback(async (encomienda) => {
    const { value: formValues } = await Swal.fire({
      title: "Gestionar encomienda",
      html: generarFormularioGestion(encomienda),
      didOpen: () => configurarEventosFormularioGestion(encomienda),
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      width: 700,
      preConfirm: () => validarYObtenerDatosGestion(encomienda),
    });

    if (!formValues) return;

    try {
      Swal.fire({ title: "Guardando", didOpen: () => Swal.showLoading(), allowOutsideClick: false });

      const nit = localStorage.getItem("CodigoCliente");
      const nombreCompleto = localStorage.getItem("NombreCompleto") || "";
      const ahora = new Date();
      const fechaHora = fechaHoraDart(ahora);

      const creacion = parsearFechaPase(encomienda.fechaCreacionOriginal);
      if (!creacion) {
        Swal.fire("Error", "El registro no tiene una fecha de creación válida", "error");
        return;
      }
      const year = String(creacion.getFullYear());
      const mes = String(creacion.getMonth() + 1).padStart(2, "0");
      const ruta = rutaEncomienda(nit, year, mes, encomienda.id);

      const cambios = {
        estado: formValues.estado,
        nombre_completo_persona_recibe_paquete: formValues.quienRecibe,
        descripcion_encomienda: bitacoraGestion(
          encomienda.descripcion_encomienda,
          nombreCompleto,
          fechaHora12Dart(ahora)
        ),
      };

      let espacio = [1, 2, 3, 4, 5, 6].find(
        n => !encomienda[`url_encomienda_${n}`]
      );
      for (const foto of formValues.fotos) {
        if (!espacio || espacio > MAX_FOTOS) break;
        cambios[`url_encomienda_${espacio}`] = await subirArchivoFirebase(
          `uploads/${nit}/${fechaHora}foto_${espacio}.jpeg`,
          foto
        );
        espacio += 1;
      }

      if (formValues.firmaNueva) {
        const blob = await fetch(formValues.firmaNueva).then(r => r.blob());
        const archivo = new File([blob], "firma.png", { type: "image/png" });
        cambios.url_firma_cliente = await subirArchivoFirebase(
          `uploads/${nit}/${fechaHora}firma.jpeg`,
          archivo
        );
      }

      if (formValues.estado === "Entregado") {
        cambios.fecha_fin_encomienda = fechaDart(ahora);
        cambios.hora_fin_encomienda = fechaHora.substring(11, 16);
      }

      await actualizarMultiple(
        Object.fromEntries(
          Object.entries(cambios).map(([clave, valor]) => [`${ruta}/${clave}`, valor])
        )
      );

      await actualizarMultiple({
        [`coordi_ph_clientes/${nit}/fcm_encomiendas/${formValues.estado.toLowerCase()}/${viviendaNotificacion(encomienda.vivienda)}`]:
          { id: encomienda.id, fecha: fechaHora },
      });

      // Correo de entrega al residente, igual que gestion_encomiendas.dart.
      let aviso = "";
      if (formValues.estado === "Entregado") {
        const correo = await correoDeVivienda(nit, encomienda.vivienda);
        let enviado = false;
        if (correo) {
          enviado = await enviarCorreoEntregaEncomienda({
            correo,
            urlFoto: cambios.url_encomienda_1 ?? encomienda.url_encomienda_1,
            urlFirma: cambios.url_firma_cliente ?? encomienda.url_firma_cliente,
            quienLoTrae: encomienda.quienLoTrae,
            nombreRecibe: formValues.quienRecibe,
            contenido: encomienda.descripcionDomicilio,
            direccion: encomienda.vivienda,
            fechaEntrega: fechaHora12Dart(ahora),
          });
        }
        aviso = mensajeNotificacion({ correo, enviado });
      }

      Swal.fire({ title: "Éxito", html: `Encomienda actualizada correctamente${aviso}`, icon: "success", confirmButtonText: "Aceptar" });
      capturarDatos();
    } catch (error) {
      console.error("Error al actualizar encomienda:", error);
      Swal.fire("Error", "No se pudo actualizar la encomienda", "error");
    }
  }, [capturarDatos]);

  const abrirArchivos = useCallback(async (filasVisibles) => {
    const guardo = await abrirMenuArchivos({
      menu: menuArchivosEncomiendas,
      columnas: COLUMNAS,
      filas: filasVisibles,
      archivoCsv: "listado_encomiendas.csv",
      descargarPlantilla: descargarPlantillaEncomiendas,
      cargar: asistenteCargarEncomiendas,
    });
    if (guardo) await capturarDatos();
  }, [capturarDatos]);

  const verFirma = (fila) => {
    if (fila.url_firma_cliente) {
      window.open(fila.url_firma_cliente, "_blank", "noopener");
    } else {
      Swal.fire("Sin firma", "Esta encomienda no tiene firma de quien recibe", "info");
    }
  };

  // Un solo botón por fila; las acciones se eligen en una ventana como la de archivos.
  const abrirAcciones = async (fila) => {
    const opcion = await menuAccionesEncomienda({
      encomienda: fila,
      cantidadFotos: fotosDe(fila).length,
      tieneFirma: Boolean(fila.url_firma_cliente),
      puedeGestionar: !esResidente(),
    });
    if (opcion === "fotos") mostrarFotos("Fotos del paquete", fotosDe(fila), "Esta encomienda no tiene fotos del paquete");
    if (opcion === "firma") verFirma(fila);
    if (opcion === "gestionar") await gestionarEncomienda(fila);
    if (opcion === "eliminar" && await eliminarConConfirmacion({
      fila, singular: "esta encomienda", descripcion: `${fila.vivienda || ""} · ${fila.estado || "Sin estado"}`,
    })) await capturarDatos();
  };

  useEffect(() => {
    capturarDatos();
  }, [capturarDatos]);

  if (cargando) return <AnimacionCarga />;

  const datosFiltradosPorEstado = filtrarPorEstado(datos, filtroEstado);

  return (
    <>
      <TablaGenerica
        datos={datosFiltradosPorEstado}
        titulos={COLUMNAS.map(c => c.label.toUpperCase())}
        campos={COLUMNAS.map(c => c.key)}
        elementosPorPagina={3000}
        columnaOrdenInicial={0}
        direccionOrdenInicial="desc"
        contenidoExtra={
          <BarraEstados datos={datos} filtro={filtroEstado} onFiltrar={setFiltroEstado}>
            <button onClick={capturarDatos} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
            <BotonArchivos onClick={() => abrirArchivos(datosFiltradosPorEstado)} />
            <button onClick={crearEncomienda} title="Crear Encomienda"><i className="bi bi-plus-lg" /></button>
          </BarraEstados>
        }
        estilosColumnas={COLUMNAS.map(c => c.estilo)}
        botones={botonOpciones(abrirAcciones)}
        tituloBotones="ACCIONES"
      />

      <BotonSOS />
    </>
  );
});

export default ListadoEncomiendas;
